// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['lodash4', '/www/lum/pub/comp/title.js', 'classnames', 'react',
    '/www/lum/pub/util/general.js', '/www/locale/pub/i18n_react.js',
    '/util/string.js',
    // Import only
    'css!/www/lum/pub/css/container'],
    (_, {Title}, classnames, React, {get_classname}, {T}, {qw})=>
{
const E = {};
const Container_title = props=>{
    let {title, subtitle, title_margin, sub_margin, variant,
        paddings, right_area, ...rest} = props;
    if (!title && !subtitle)
        return null;
    if (title_margin==null)
        title_margin = subtitle ? 4 : 24;
    if (sub_margin==null)
        sub_margin = title ? 24 : 23;
    if (paddings)
    {
        title_margin = 0;
        sub_margin = 0;
    }
    let rest_sub = {...rest};
    if (variant)
        rest[variant] = true;
    return <div className={classnames('cp_container_title',
      paddings && 'cp_container_title_padding')}>
      <div className="cp_container_title_wrapper">
        {!!title &&
          <Title text={title} style={{marginBottom: title_margin}}
            {...rest}/>}
        {!!subtitle &&
          <Title text={subtitle} sub style={{marginBottom: sub_margin}}
            {...rest_sub}/>}
      </div>
      {!!right_area &&
        <div className="cp_container_title_right">{right_area}</div>}
    </div>;
};

const Container = React.forwardRef(function Container(props, ref){
    let {id, name, title, subtitle, tag, title_margin, sub_margin,
        classes, children, forward_ref, tag_right, content_margin_l,
        title_variant, title_classes, separate, header_content,
        ...rest} = props;
    if (separate)
        rest.no_padding = true;
    let opts = qw`no_style no_border no_padding elevated wide no_padding_b`;
    let cls = get_classname('cp_container', classes, opts, rest);
    let content_cls = get_classname('cp_container_content',
        '', qw`row top paddings`, {...rest, paddings: separate});
    let tag_cls = get_classname('cp_container_tag', '', 'right',
        {right: tag_right});
    let on_content_click = e=>{
        e.stopPropagation();
    };
    return <div id={id||name} className={cls} ref={forward_ref||ref}
      {..._.omit(rest, opts)}>
      {tag &&
        <div className={tag_cls}>
          {_.isString(tag) ? <T>{tag}</T> : tag}
        </div>}
      <Container_title title={title} subtitle={subtitle}
        title_margin={title_margin} sub_margin={sub_margin}
        variant={title_variant} paddings={!!separate}
        classes={title_classes} right_area={header_content}/>
      <div className={content_cls} style={content_margin_l ?
        {marginLeft: content_margin_l} : {}} onClick={on_content_click}>
        {children}</div>
    </div>;
});
const Container_step = props=>{
    let {children, classes, step, disabled_overlay, title, subtitle,
        title_margin, sub_margin, hide_step, ...rest} = props;
    let cls = get_classname('cp_container_step', classes, qw`active last done
        disabled`, rest);
    return <Container {...rest} classes={cls} row no_style>
          {!!disabled_overlay && !rest.active &&
            <div className="cp_container_step_disabled_overlay"></div>}
          {!hide_step &&
            <div className="cp_container_step_step_wrapper">
              <div className="cp_container_step_step">{step}</div>
            </div>}
          <div className="cp_container_step_content">
            <Container_title title={title} subtitle={subtitle}
              title_margin={title_margin} sub_margin={sub_margin} small/>
            {children}
          </div>
        </Container>;
};
Object.assign(E, {Container, Container_step});
return E;
});
